import * as d3 from "d3";
import AlarmLogic from "../../../logic/alarmLogic";
import AppSettings from "../../../metMap/appSettings";
import { MapAppMode } from "../mapAppMode";
export default class MPointMarker {
    get color() {
        if (AppSettings.AppMode === MapAppMode.POWMON) {
            //if (this.isPowMonProd)
            //    return d3.hsl(ColorStyling.productionPower);
            //else if (this.isPowMon)
            //    return d3.hsl(ColorStyling.consumptionPower);
            //return d3.hsl("#ddd");
        }
        else if (!isNaN(this.alarmRatio))
            return d3.hsl(d3.interpolateHsl("green", "red")(this.alarmRatio));
        return d3.hsl("lightgrey");
    }
    get alarmRatio() {
        return AlarmLogic.worstAlarmRatio(this._mpoint);
    }
    //get isPowMonProd(): boolean {
    //    return PowMon.mpointIdsProd().includes(this._mpoint.id);
    //}
    //get isPowMon(): boolean {
    //    return PowMon.mpointIds().includes(this._mpoint.id);
    //}
    get glowSize() {
        if (AppSettings.AppMode === MapAppMode.POWMON) {
            //if(this.isPowMon||this.isPowMonProd)
            //    return 20;
        }
        if (this.alarmRatio) {
            return d3.interpolateNumber(0, 20)(this.alarmRatio);
        }
        return 0;
    }
    get r() { return 5; }
    get labelText() {
        return `${this._mpoint.name}`;
    }
    get hullId() {
        return this._mpoint.hullId;
    }
}
